import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import "jspdf-autotable";
import { useNavigate } from "react-router-dom";
import axiosInstance from '../axiosInstance';
import html2pdf from 'html2pdf.js';

function Billing() {
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [invoiceData, setInvoiceData] = useState(null);
    const [fileData, setFileData] = useState(null);
    const [startDate, setStartDate] = useState('');
    const [registrations, setRegistrations] = useState([]);
    const [company, setCompanyData] = useState({});
    const [formData, setFormData] = useState({
        dealer_id: '',
        reg_no: '',
        bike_model: '',
        bike_make_year: '',
        bike_color: '',
        bike_chase_no: '',
        bike_engine_no: '',
        buyer_name: '',
        buyer_address1: '',
        buyer_address2: '',
        buyer_city: '',
        buyer_phone1: '',
        buyer_phone2: '',
        seller_name: '',
        seller_address1: '',
        seller_address2: '',
        seller_city: '',
        seller_phone1: '',
        seller_phone2: '',
        amount: '',
        date_time: '',
        payment_type1: '',
        payment_type2: '',
        cash_paid1: '',
        cash_paid2: '',
        finance_id: '',
        finance_amount: '',
        emi_tenure: '',
        emi_amount: '',
        due_date: '',
        exchange_id: '',
        exchange_reg_no: '',
        exchange_bike_model: '',
        exchange_bike_make: '',
        exchange_bike_color: '',
        exchange_bike_chase_no: '',
        exchange_bike_engine_no: '',
        exchange_amount: '',
        isfinance: '',
        isexchange: '',
    });
    const [loading, setLoading] = useState(true);

    const today = new Date();
    const formattedDate = today.toLocaleDateString("en-GB"); // Format as DD/MM/YYYY

    const [files, setFiles] = useState({
        aadhar_file: null,
        rc_file: null,
        photo_file: null,
        photowithbike_file: null,
    });

    const [errors, setErrors] = useState({
        buyer_name: '',
        buyer_address1: '',
        buyer_phone1: '',
        seller_name: '',
        seller_address1: '',
        seller_phone1: '',
        reg_no: '',
        amount: '',
        date_time: '',
        payment_type1: '',
        cash_paid1: '',
        //aadhar_file: "",
        //rc_file: "",
        //photo_file: "",
        //photowithbike_file: "",
    });

    const allowedFormats = ["application/pdf", "image/jpeg", "image/png"];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosInstance.get(`/dealer/listforbilling`);
                //console.log(response.data)
                setRegistrations(response.data);
            } catch (error) {
                console.error('Error fetching data:', error);
                setRegistrations([]);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        const storedData = {
            seller_name: localStorage.getItem('companyname') || '',
            seller_address1: localStorage.getItem('address1') || '',
            seller_address2: localStorage.getItem('address2') || '',
            seller_city: localStorage.getItem('city') || '',
            seller_phone1: localStorage.getItem('Phone1') || '',
            seller_phone2: localStorage.getItem('phone2') || '',
        };

        setFormData((prevFormData) => ({
            ...prevFormData,
            ...storedData,
        }));
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const companyid = localStorage.getItem("company_id");
                const response = await axiosInstance.get(`/billsettings/company`);
                console.log(response.data.data)
                const company = response.data.data[0]; // first object

                const userData = {
                    company_name: company?.company_name || '',
                    company_address1: company?.company_address1 || '',
                    company_address2: company?.company_address2 || '',
                    company_city: company?.company_city || '',
                    company_phone1: company?.company_phone1 || '',
                    company_phone2: company?.company_phone2 || '',
                };
                setCompanyData(userData);
            } catch (error) {
                console.error('Error fetching data:', error);
                setCompanyData([]);
            }
        };

        fetchData();
    }, []);

    // Validation function
    const validateForm = () => {
        let formErrors = {}; // Store validation errors
        const phoneRegex = /^\d{10}$/; // Phone and WhatsApp validation regex (10 digits)


        // Check if required fields are empty (if a field is required, you can add custom logic here)
        if (!formData.buyer_name) {
            formErrors.buyer_name = "From Name is required";
        }

        if (!formData.buyer_address1) {
            formErrors.buyer_address1 = "From Address1 is required";
        }

        if (!formData.seller_name) {
            formErrors.seller_name = "To Name is required";
        }

        if (!formData.seller_address1) {
            formErrors.seller_address1 = "To Address1 is required";
        }


        if (!formData.reg_no) {
            formErrors.reg_no = "Register Number is required";
        }

        if (!formData.amount) {
            formErrors.amount = "Amount is required";
        }

        if (!startDate) {
            formErrors.date_time = "Bill Date & Time is required";
        }

        if (!formData.payment_type1) {
            formErrors.payment_type1 = "Payment Type is required";
        }

        if (!formData.cash_paid1) {
            formErrors.cash_paid1 = "Cash Paid is required";
        }

        // if (!files.aadhar_file) {
        //     formErrors.aadhar_file = "Aadhaar is required";
        // }

        // if (!files.rc_file) {
        //     formErrors.rc_file = "Rc is required";
        // }

        // if (!files.photo_file) {
        //     formErrors.photo_file = "Photo is required";
        // }

        // if (!files.photowithbike_file) {
        //     formErrors.photowithbike_file = "Photo With Bike is required";
        // }

        // Check phone numbers

        if (!phoneRegex.test(formData.seller_phone1)) {
            formErrors.seller_phone1 = 'Please enter a valid 10-digit phone number';
        }

        if (!phoneRegex.test(formData.buyer_phone1)) {
            formErrors.buyer_phone1 = 'Please enter a valid 10-digit phone number';
        }

        // If there are errors, set them in the state and return false
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors); // Store the errors in the state
            return false; // Validation failed
        }

        // Return true if no errors
        return true;
    };

    // Handle form input change
    // const handleInputChange = (e) => {
    //     const { name, type, checked, value } = e.target;

    //     setFormData({
    //         ...formData,
    //         [name]: type === 'checkbox' ? checked : value,
    //     });
    // };

    const handleInputChange = async (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === 'checkbox' ? checked : value;

        if (name === "date_time") {
            setStartDate(newValue);
            setFormData((prev) => ({
                ...prev,
                [name]: newValue,
            }));
            return;
        }

        if (name === "reg_no" && registrations.length > 0) {
            const selected = registrations.find(
                item => item.reg_no.trim().toLowerCase() === value.trim().toLowerCase()
            );
            if (selected) {
                //console.log("selected: ",selected)
                setFormData(prev => ({
                    ...prev,
                    reg_no: value,
                    dealer_id: selected.id || '',
                    bike_model: selected.model || '',
                    bike_make_year: selected.make_year || '',
                    bike_color: selected.color?.trim() || '',
                    bike_chase_no: selected.chase_no?.trim() || '',
                    bike_engine_no: selected.engine_no?.trim() || ''
                }));
            } else {
                setFormData(prev => ({
                    ...prev,
                    reg_no: value,
                    dealer_id: '',
                    bike_model: '',
                    bike_make_year: '',
                    bike_color: '',
                    bike_chase_no: '',
                    bike_engine_no: ''
                }));
            }
            return;
        }

        if ((name === "isfinance" || name === "isexchange") && formData.reg_no) {
            const regNo = formData.reg_no;

            // Update the checked status of the box
            const updatedCheckboxes = {
                ...formData,
                [name]: checked,
            };

            let finance = null;
            let exchange = null;

            try {
                if (updatedCheckboxes.isfinance) {
                    const res = await axiosInstance.get(`/finance/reg/${regNo}`);
                    finance = res.data;
                }
                if (updatedCheckboxes.isexchange) {
                    const res = await axiosInstance.get(`/exchange/reg/${regNo}`);
                    exchange = res.data.data;
                }

                setFormData(prev => {
                    const updated = {
                        ...prev,
                        ...updatedCheckboxes,
                    };

                    // Update Finance Fields
                    if (finance) {
                        updated.finance_id = finance.id || '';
                        updated.finance_amount = finance.loan_amount || '';
                        updated.emi_tenure = finance.tenure_months || '';
                        updated.emi_amount = finance.emi_amount || '';
                        updated.due_date = finance.due_date || '';
                    } else {
                        updated.finance_id = '';
                        updated.finance_amount = '';
                        updated.emi_tenure = '';
                        updated.emi_amount = '';
                        updated.due_date = '';
                    }

                    // Update Exchange Fields
                    if (exchange) {
                        updated.exchange_id = exchange.id || '';
                        updated.exchange_reg_no = exchange.exchange_reg_no || '';
                        updated.exchange_bike_model = exchange.exchange_bike_model || '';
                        updated.exchange_bike_make = exchange.exchange_bike_make || '';
                        updated.exchange_bike_color = exchange.exchange_bike_color || '';
                        updated.exchange_bike_chase_no = exchange.exchange_bike_chase_no || '';
                        updated.exchange_bike_engine_no = exchange.exchange_bike_engine_no || '';
                        updated.exchange_amount = exchange.amount || '';
                    } else {
                        updated.exchange_id = '';
                        updated.exchange_reg_no = '';
                        updated.exchange_bike_model = '';
                        updated.exchange_bike_make = '';
                        updated.exchange_bike_color = '';
                        updated.exchange_bike_chase_no = '';
                        updated.exchange_bike_engine_no = '';
                        updated.exchange_amount = '';
                    }

                    // Decide Buyer Info
                    if (updated.isfinance && finance) {
                        updated.buyer_name = finance.borrower_name || '';
                        updated.buyer_address1 = finance.borrower_address1 || '';
                        updated.buyer_address2 = `${finance.borrower_address2 || ''} ${finance.borrower_address3 || ''}`.trim();
                        updated.buyer_city = finance.borrower_city || '';
                        updated.buyer_phone1 = finance.borrower_phone1 || '';
                        updated.buyer_phone2 = finance.borrower_phone2 || '';
                    } else if (updated.isexchange && exchange) {
                        updated.buyer_name = exchange.name || '';
                        updated.buyer_address1 = exchange.address1 || '';
                        updated.buyer_address2 = exchange.address2 || '';
                        updated.buyer_city = exchange.city || '';
                        updated.buyer_phone1 = exchange.phone1 || '';
                        updated.buyer_phone2 = exchange.phone2 || '';
                    } else {
                        // If neither selected
                        updated.buyer_name = '';
                        updated.buyer_address1 = '';
                        updated.buyer_address2 = '';
                        updated.buyer_city = '';
                        updated.buyer_phone1 = '';
                        updated.buyer_phone2 = '';
                    }

                    return updated;
                });

            } catch (err) {
                console.error("Error fetching finance/exchange data:", err);
            }

            return;
        }

        // All other input types
        setFormData(prev => ({
            ...prev,
            [name]: newValue,
        }));
    };


    const handleFileChange = (e) => {
        const { id, files } = e.target;
        const file = files[0];

        if (file) {
            const { type, size } = file;

            // Validate file format
            if (!allowedFormats.includes(type)) {
                setErrors((prev) => ({
                    ...prev,
                    [id]: "Invalid file type! Only PDF, JPG, and PNG allowed.",
                }));
                setFiles((prev) => ({ ...prev, [id]: null }));
                return;
            }

            // Validate file size
            if (
                (type === "application/pdf" && size > 100 * 1024) ||
                ((type === "image/jpeg" || type === "image/png") && size > 50 * 1024)
            ) {
                setErrors((prev) => ({
                    ...prev,
                    [id]: `File too large! Max size: ${type === "application/pdf" ? "100KB (PDF)" : "50KB (Image)"
                        }`,
                }));
                setFiles((prev) => ({ ...prev, [id]: null }));
                return;
            }

            // Clear errors and set file
            setErrors((prev) => ({ ...prev, [id]: "" }));
            setFiles((prev) => ({ ...prev, [id]: file }));
        }
    };

    // const printBill = () => {
    //     const printContents = document.getElementById("download_section").innerHTML;
    //     //const originalContents = document.body.innerHTML;

    //     document.body.innerHTML = printContents;  // Replace body content with invoice
    //     window.print();  // Trigger the print dialog
    //     // Instead of restoring innerHTML manually, reload the page
    //     window.location.reload();
    // };

    // Replace your printBill function with this exact code:

    const printBill = () => {
        const printContents = document.getElementById("download_section").innerHTML;
        document.body.innerHTML = printContents;

        const images = document.body.getElementsByTagName("img");
        let loadedCount = 0;
        const totalImages = images.length;

        if (totalImages === 0) {
            window.print();
            window.location.reload();
            return;
        }

        const tryPrint = () => {
            loadedCount++;
            if (loadedCount === totalImages) {
                window.print();
                window.location.reload();
            }
        };

        for (let img of images) {
            if (img.complete) {
                // ✅ Already loaded (cached) - count it immediately
                tryPrint();
            } else {
                img.onload = tryPrint;
                img.onerror = tryPrint; // ✅ Still count even if image fails
            }
        }
    };

    // Add this function alongside printBill
    const downloadPDF = () => {
        const element = document.getElementById("download_section");
        element.style.display = "block";

        // ✅ Get the actual rendered width of the element
        const elementWidth = element.scrollWidth;
        const elementHeight = element.scrollHeight;

        const options = {
            margin: 0,
            filename: `Bill_${invoiceData?.bill_no || 'invoice'}.pdf`,
            image: { type: 'jpeg', quality: 1.0 },
            html2canvas: {
                scale: 1,
                useCORS: true,
                allowTaint: false,
                logging: false,
                width: elementWidth,
                height: elementHeight,
                windowWidth: elementWidth,   // ✅ exact element width — no rescaling
                windowHeight: elementHeight,
            },
            jsPDF: {
                unit: 'px',
                format: [elementWidth, elementHeight], // ✅ PDF page = exact element size
                orientation: 'portrait',
                hotfixes: ['px_scaling'],              // ✅ prevents double scaling
            }
        };

        html2pdf()
            .set(options)
            .from(element)
            .save()
            .then(() => {
                element.style.display = "none";
            });
    };

    function formatDateTimeToIndian(input) {
        const date = new Date(input);
        const options = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: 'Asia/Kolkata'
        };

        return new Intl.DateTimeFormat('en-IN', options).format(date);
    }

    const savebilling = async (event) => {
        event.preventDefault();

        // Prevent multiple submissions
        if (isSaving || isSaved) return;

        if (validateForm()) {
            setIsSaving(true); // Disable the button

            setLoading(true);
            setErrors({});

            try {

                const dateObj = new Date(startDate);
                if (isNaN(dateObj)) {
                    throw new Error("Invalid date format");
                }

                const formattedDate = dateObj.toISOString().split('T')[0];
                const formattedDateTime = startDate;
                console.log("IST Time:", formattedDateTime);
                // Get user ID from localStorage
                const created_by = localStorage.getItem('user_id');
                let billingId = "";
                let billno = "";
                let dealerId = "";
                let amt_in_words = "";

                // Add new fields to formData
                const updatedFormData = {
                    ...formData,
                    date: formattedDate,        // Stores only the date
                    date_time: formattedDateTime,     // Stores both date and time
                    created_by: created_by,
                };
                console.log(updatedFormData)
                // Step 1: Save form data to billing API

                try {
                    const formResponse = await axiosInstance.post('/billing/add', updatedFormData);
                    console.log(formResponse.data)
                    console.log(formResponse.data.data.id)
                    dealerId = formResponse.data.data.dealer_id;
                    billingId = formResponse.data.data.id; // Get billing ID
                    billno = formResponse.data.data.bill_no; // Get billing ID
                    amt_in_words = formResponse.data.data.amountinwords;

                    const finaldata = {
                        ...updatedFormData,
                        bill_no: billno,
                        dealer_id: dealerId,
                        amountinwords: amt_in_words,      // Stores billingid to updatedfordata
                    };
                    setInvoiceData(finaldata);
                    console.log("DealerID:", dealerId)
                    console.log("Finaldata:", finaldata)
                }
                catch (error) {
                    console.error('Error saving data:', error);
                    // Extract error message from API response
                    let errorMessage = 'There was an issue in saving the record.';
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message; // Get error message from backend response
                    }
                    setInvoiceData([]);

                    Swal.fire({
                        icon: 'error',
                        title: 'Error!',
                        text: errorMessage,
                    });
                }

                console.log(billingId)


                try {
                    if (files.rc_file || files.aadhar_file || files.photo_file || files.photowithbike_file) {
                        if (billingId) {
                            // Step 2: Save file data with billing_id
                            const formDataWithFile = new FormData();
                            formDataWithFile.append("billing_id", billingId); // Send billing ID
                            formDataWithFile.append("created_by", created_by); // Send user ID (or get from session)
                            formDataWithFile.append("rc_file", files.rc_file);
                            formDataWithFile.append("aadhar_file", files.aadhar_file);
                            formDataWithFile.append("photo_file", files.photo_file);
                            formDataWithFile.append("photowithbike_file", files.photowithbike_file);

                            const fileResponse = await axiosInstance.post("/fileupload/upload", formDataWithFile,
                                { headers: { "Content-Type": "multipart/form-data" } }
                            );
                            console.log("File Data: ", fileResponse.data);
                            console.log("File Data Data: ", fileResponse.data.data);
                            setFileData(fileResponse.data.data);
                            // Update finaldata with file information for immediate use
                            const finaldata = {
                                ...updatedFormData,
                                bill_no: billno,
                                dealer_id: dealerId,
                                amountinwords: amt_in_words,
                                // Add file data directly to finaldata
                                fileData: fileResponse.data.data
                            };
                            setInvoiceData(finaldata);
                            if (dealerId) {
                                // Step 3: Update dealer finance flag
                                const updateResponse = await axiosInstance.delete(`/dealer/${dealerId}`, null, {
                                    headers: {
                                        'Content-Type': 'application/json',
                                    }
                                });

                                console.log("Dealer updated:", updateResponse.data.message);
                            } else {
                                console.warn("Dealer ID not found in record data.");
                            }
                            setIsSaved(true);
                            Swal.fire('Saved!', 'Form and file saved successfully', 'success');

                        }
                    }
                    else {
                        // When no files are uploaded, still update finaldata
                        const finaldata = {
                            ...updatedFormData,
                            bill_no: billno,
                            dealer_id: dealerId,
                            amountinwords: amt_in_words,
                            fileData: null // Explicitly set to null when no files
                        };
                        setInvoiceData(finaldata);
                        if (dealerId) {
                            // Step 3: Update dealer finance flag
                            const updateResponse = await axiosInstance.delete(`/dealer/${dealerId}`, null, {
                                headers: {
                                    'Content-Type': 'application/json',
                                }
                            });

                            console.log("Dealer updated:", updateResponse.data.message);
                        } else {
                            console.warn("Dealer ID not found in record data.");
                        }
                        setIsSaved(true);
                        Swal.fire('Saved!', 'Bill saved successfully', 'success');
                    }

                }
                catch (error) {
                    console.error('Error saving File:', error);
                    // Extract error message from API response
                    let errorMessage = 'There was an issue in saving the record.';
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message; // Get error message from backend response
                    }
                    setFileData([]);

                    Swal.fire({
                        icon: 'error',
                        title: 'Error saving File!',
                        text: errorMessage,
                    });
                }

                // Success
                //alert('Form and file saved successfully');
                //Swal.fire('Saved!', 'Form and file saved successfully', 'success');


            } catch (error) {
                setErrors((prev) => ({ ...prev, form: error.message }));
            } finally {
                setLoading(false);
            }
            setIsSaving(false); // Re-enable the button
        }
    };

    const handleClear = () => {
        setInvoiceData({});
        setFileData({});
        setFiles([]);
        setErrors({});

        // Navigate without reload
        navigate("/billing", { replace: true });
    };


    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Billing</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section class="content">
                <div class="container-fluid">

                    <div class="row">
                        <div class="col-md-12">
                            <div class="card card-dark">
                                <div class="card-header">
                                    <h3 class="card-title">Billing</h3>
                                </div>
                                <form onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                    }
                                }}>
                                    <div class="card-body">
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label>Registration No</label>
                                                    <select
                                                        id="reg_no"
                                                        name="reg_no"
                                                        className="form-control select2"
                                                        value={formData.reg_no}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select a Registration No</option>
                                                        {registrations.map(item => (
                                                            <option key={item.id} value={item.reg_no}>
                                                                {item.reg_no}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors.reg_no && <small className="text-danger">{errors.reg_no}</small>}
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label>Model</label>
                                                    <input type="text" id="bike_model" name="bike_model" value={formData.bike_model} onChange={handleInputChange} className="form-control" readOnly />
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label>Make Year</label>
                                                    <input type="text" name="bike_make_year" value={formData.bike_make_year} onChange={handleInputChange} className="form-control" readOnly />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label>Color</label>
                                                    <input type="text" name="bike_color" value={formData.bike_color} onChange={handleInputChange} className="form-control" readOnly />
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label>Chassis Number</label>
                                                    <input type="text" name="bike_chase_no" value={formData.bike_chase_no} onChange={handleInputChange} className="form-control" readOnly />
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <label>Engine Number</label>
                                                    <input type="text" name="bike_engine_no" value={formData.bike_engine_no} onChange={handleInputChange} className="form-control" readOnly />
                                                </div>
                                            </div>
                                        </div>

                                        <hr class="divider"></hr>

                                        <label for="from">Finance & Exchange Documentation :</label>
                                        <div class="row">
                                            <div class="col-md-3">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-dark" type="checkbox" id="isfinance" name="isfinance" checked={formData.isfinance || false} onChange={handleInputChange} />
                                                    <label htmlFor="isfinance" class="custom-control-label">Finance</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-dark" type="checkbox" id="isexchange" name="isexchange" checked={formData.isexchange || false} onChange={handleInputChange} />
                                                    <label htmlFor="isexchange" class="custom-control-label">Exchange</label>
                                                </div>
                                            </div>
                                        </div>

                                        <hr class="divider"></hr>

                                        <label for="from">Buyer:</label>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="buyer_name">Name</label>
                                                    <input type="text" class="form-control" value={formData.buyer_name} onChange={handleInputChange} name="buyer_name" placeholder="Enter Name" />
                                                    {errors.buyer_name && <small className="text-danger">{errors.buyer_name}</small>}
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="buyer_address1">Address Line 1</label>
                                                    <input type="text" class="form-control" value={formData.buyer_address1} onChange={handleInputChange} name="buyer_address1" placeholder="Enter Address" />
                                                    {errors.buyer_address1 && <small className="text-danger">{errors.buyer_address1}</small>}
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="buyer_address2">Address Line 2</label>
                                                    <input type="text" class="form-control" value={formData.buyer_address2} onChange={handleInputChange} name="buyer_address2" placeholder="Enter Address Line 2" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="buyer_city">City / District</label>
                                                    <input type="text" class="form-control" value={formData.buyer_city} onChange={handleInputChange} name="buyer_city" placeholder="Enter City / District" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="buyer_phone1">Primary Phone</label>
                                                    <input type="text" class="form-control" value={formData.buyer_phone1} onChange={handleInputChange} name="buyer_phone1" placeholder="Enter Phone Number" />
                                                    {errors.buyer_phone1 && <small className="text-danger">{errors.buyer_phone1}</small>}

                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="buyer_phone2">Alternate Phone</label>
                                                    <input type="text" class="form-control" value={formData.buyer_phone2} onChange={handleInputChange} name="buyer_phone2" placeholder="Enter Phone Number" />
                                                </div>
                                            </div>
                                        </div>

                                        <label for="to">Seller:</label>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="seller_name">Name</label>
                                                    <input type="text" class="form-control" value={formData.seller_name} onChange={handleInputChange} name="seller_name" placeholder="Enter Name" />
                                                    {errors.seller_name && <small className="text-danger">{errors.seller_name}</small>}
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="seller_address1">Address Line 1</label>
                                                    <input type="text" class="form-control" value={formData.seller_address1} onChange={handleInputChange} name="seller_address1" placeholder="Enter Address" />
                                                    {errors.seller_address1 && <small className="text-danger">{errors.seller_address1}</small>}
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="seller_address2">Address Line 2</label>
                                                    <input type="text" class="form-control" value={formData.seller_address2} onChange={handleInputChange} name="seller_address2" placeholder="Enter Address Line 2" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="seller_city">City / District</label>
                                                    <input type="text" class="form-control" value={formData.seller_city} onChange={handleInputChange} name="seller_city" placeholder="Enter City / District" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="seller_phone1">Primary Phone</label>
                                                    <input type="text" class="form-control" value={formData.seller_phone1} onChange={handleInputChange} name="seller_phone1" placeholder="Enter Phone Number" />
                                                    {errors.seller_phone1 && <small className="text-danger">{errors.seller_phone1}</small>}
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="seller_phone2">Alternate Phone</label>
                                                    <input type="text" class="form-control" value={formData.seller_phone2} onChange={handleInputChange} name="seller_phone2" placeholder="Enter Phone Number" />
                                                </div>
                                            </div>
                                        </div>

                                        <hr class="divider"></hr>
                                        <label for="from">Payment Details:</label>
                                        <div class="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Bill Date & Time:</label>
                                                    <input
                                                        type="datetime-local"
                                                        className="form-control"
                                                        name="date_time"
                                                        value={startDate}
                                                        onChange={handleInputChange}
                                                    />
                                                    {errors.date_time && <small className="text-danger">{errors.date_time}</small>}
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="amount">Bill Amount</label>
                                                    <input type="text" class="form-control" value={formData.amount} onChange={handleInputChange} name="amount" placeholder="Enter Amount" />
                                                    {errors.amount && <small className="text-danger">{errors.amount}</small>}
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="payment_type1">Primary Payment Type</label>
                                                    <select className="form-control select2" style={{ width: "100%" }} name="payment_type1" value={formData.payment_type1} onChange={handleInputChange} >
                                                        <option value="" disabled>Select Primary Payment Type</option>
                                                        <option value="Cash">Cash</option>
                                                        <option value="Card">Card</option>
                                                        <option value="UPI">UPI</option>
                                                    </select>
                                                    {errors.payment_type1 && <small className="text-danger">{errors.payment_type1}</small>}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="cash_paid1">Primary Cash Amount</label>
                                                    <input type="text" class="form-control" value={formData.cash_paid1} onChange={handleInputChange} name="cash_paid1" placeholder="Enter Primary Cash Amount" />
                                                    {errors.cash_paid1 && <small className="text-danger">{errors.cash_paid1}</small>}
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="payment_type2">Secondary Payment Type</label>
                                                    <select className="form-control select2" style={{ width: "100%" }} name="payment_type2" value={formData.payment_type2} onChange={handleInputChange} >
                                                        <option value="" disabled>Select Secondary Payment Type</option>
                                                        <option value="Cash">Cash</option>
                                                        <option value="Card">Card</option>
                                                        <option value="UPI">UPI</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="cash_paid2">Secondary Cash Amount</label>
                                                    <input type="text" class="form-control" value={formData.cash_paid2} onChange={handleInputChange} name="cash_paid2" placeholder="Enter Secondary Cash Amount" />
                                                </div>
                                            </div>
                                        </div>

                                        {/* <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="emi_tenure">EMI / Tenure</label>
                                                    <input type="text" class="form-control" value={formData.emi_tenure} onChange={handleInputChange} name="emi_tenure" placeholder="Enter EMI / Tenure" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="balance">Balance</label>
                                                    <input type="text" class="form-control" value={formData.balance} onChange={handleInputChange} name="balance" placeholder="Enter Balance" />
                                                </div>
                                            </div>
                                        </div>*/}

                                        {/* <label for="from">Exchange Details:</label>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="exchange_of">Exchange Of</label>
                                                    <input type="text" class="form-control" value={formData.exchange_of} onChange={handleInputChange} name="exchange_of" placeholder="Enter Exchange Of" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="exchange_amout">Exchange Amount</label>
                                                    <input type="text" class="form-control" value={formData.exchange_amout} onChange={handleInputChange} name="exchange_amout" placeholder="Enter Amount" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="exchange_reg_no">Exchange Registration No</label>
                                                    <input type="text" class="form-control" value={formData.exchange_reg_no} onChange={handleInputChange} name="exchange_reg_no" placeholder="Enter Registration No" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="exchange_bike_model">Exchange Bike Model</label>
                                                    <input type="text" class="form-control" value={formData.exchange_bike_model} onChange={handleInputChange} name="exchange_bike_model" placeholder="Enter Bike Model" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="exchange_bike_make">Exchange Bike Make</label>
                                                    <input type="text" class="form-control" value={formData.exchange_bike_make} onChange={handleInputChange} name="exchange_bike_make" placeholder="Enter Bike Make" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="exchange_bike_color">Exchange Bike Color</label>
                                                    <input type="text" class="form-control" value={formData.exchange_bike_color} onChange={handleInputChange} name="exchange_bike_color" placeholder="Enter Bike Color" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="exchange_bike_chase_no">Exchange Chase No</label>
                                                    <input type="text" class="form-control" value={formData.exchange_bike_chase_no} onChange={handleInputChange} name="exchange_bike_chase_no" placeholder="Enter Chase No" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="exchange_bike_engine_no">Exchange Engine No</label>
                                                    <input type="text" class="form-control" value={formData.exchange_bike_engine_no} onChange={handleInputChange} name="exchange_bike_engine_no" placeholder="Enter Engine No" />
                                                </div>
                                            </div>
                                        </div>*/}



                                        <hr class="divider"></hr>

                                        {["aadhar_file", "rc_file", "photo_file", "photowithbike_file"].map((field) => (
                                            <div key={field} className="form-group">
                                                <label htmlFor={field}>
                                                    {field.replace("_file", "").toUpperCase()}
                                                </label>
                                                <div className="input-group">
                                                    <div className="custom-file">
                                                        <input
                                                            type="file"
                                                            className="custom-file-input"
                                                            id={field}
                                                            onChange={handleFileChange}
                                                            accept=".pdf,.jpg,.jpeg,.png"
                                                        />
                                                        <label className="custom-file-label">
                                                            {files[field] ? files[field].name : "Choose file"}
                                                        </label>
                                                    </div>
                                                </div>
                                                {errors[field] && <small className="text-danger">{errors[field]}</small>}
                                            </div>
                                        ))}
                                    </div>

                                    <div class="card-footer">
                                        <button type="submit" class="btn btn-primary" onClick={savebilling} disabled={isSaving || isSaved}>{isSaved ? 'Bill Saved' : isSaving ? 'Saving...' : 'Save Bill'}</button>
                                        {/* Print and Download Buttons */}
                                        {isSaved && (
                                            <div>
                                                <button type="button" className="btn btn-secondary mb-4 mr-2" onClick={printBill} style={{ marginTop: '10px' }}>
                                                    Print
                                                </button>
                                                <button type="button" className="btn btn-danger mb-4 mr-2" onClick={downloadPDF} style={{ marginTop: '10px' }}>
                                                    {/* ✅ new download button */}
                                                    <i className="fa fa-download mr-1"></i> Download PDF
                                                </button>
                                                <button type="button" className="btn btn-success mb-4" onClick={handleClear} style={{ marginTop: '10px' }}>
                                                    clear
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </section >

            {invoiceData && (
                <div id="download_section" style={{ display: "none" }}>
                    <div className="delivery-note-container">
                        <div class="note-header">
                            <div class="note-header-left">
                                <img
                                    src={`https://apiemiride.socialpartners.in/api/company/logo/${encodeURIComponent(localStorage.getItem('company_logo') || '')}`}
                                    alt="Company Logo"
                                    className="company-logo"
                                    onError={(e) => { e.target.style.display = "none"; }}
                                />
                            </div>
                            <div class="note-header-center">
                                <h1 class="brand-name">{company.company_name}</h1>
                                <p class="brand-tamil">{company.tagline}</p>
                                <p class="brand-line">BUYING - SELLING - EXCHANGE</p>
                            </div>
                            <div class="note-header-right">
                                <p><i class="fas fa-map-marker-alt location-icon"></i> {company.company_address1}</p>
                                <p><i class="fas fa-map-marker-alt location-icon"></i> {company.company_address2} , {company.company_city}</p>
                                <p><i class="fa fa-solid fa-phone location-icon"></i> {company.company_phone1}, {company.company_phone2}</p>
                            </div>
                        </div>

                        <div className="delivery-note-section">
                            {/* Left Section for DN No. and Date */}
                            <div className="delivery-note-left">
                                <p><strong>Bill No:</strong>{invoiceData.bill_no}</p>
                                <p><strong>Date:</strong>{invoiceData.date}</p>
                            </div>
                            <div className="delivery-note-header">
                                <h3 className="delivery-note-title"><strong>DELIVERY NOTE</strong></h3>
                            </div>

                            {/* Right Section for Image */}

                            <div className="delivery-note-image">
                                <div className={`delivery-note-image-container ${!invoiceData.fileData?.photo_file ? 'no-border' : ''}`}>
                                    {console.log(
                                        "Buyer image URL:",
                                        invoiceData.fileData?.photo_file
                                            ? `https://apiemiride.socialpartners.in/api/fileupload/uploads/buyer/${invoiceData.fileData.company_id}/${invoiceData.fileData.photo_file}`
                                            : "No image available"
                                    )}
                                    <img
                                        src={
                                            invoiceData.fileData?.photo_file
                                                ? `https://apiemiride.socialpartners.in/api/fileupload/uploads/buyer/${invoiceData.fileData.company_id}/${invoiceData.fileData.photo_file}`
                                                : "https://via.placeholder.com/160x160/ffffff/ffffff.png"
                                        }
                                        alt="Buyer"
                                        className="fixed-image"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="delivery-note-info">
                            <div>
                                <h3 className="delivery-note-fromto"><span className="highlight-text">Buyer</span>:</h3>
                                <p><strong><b>{invoiceData.buyer_name}</b></strong></p>
                                <p>{invoiceData.buyer_address1}</p>
                                <p>{invoiceData.buyer_address2} , {invoiceData.buyer_city}</p>
                                <p>
                                    <strong>Phone:</strong> <strong><b>{invoiceData.buyer_phone1}, {invoiceData.buyer_phone2}</b></strong>
                                </p>
                            </div>
                            <div>
                                <h3 className="delivery-note-fromto"><span className="highlight-text">Seller</span>:</h3>
                                <p><strong><b>{invoiceData.seller_name}</b></strong></p>
                                <p>{invoiceData.seller_address1}</p>
                                <p>{invoiceData.seller_address2} , {invoiceData.seller_city}</p>
                                <p>
                                    <strong>Phone:</strong> <strong><b>{invoiceData.seller_phone1}, {invoiceData.seller_phone2}</b></strong>
                                </p>
                            </div>
                        </div>

                        <div className="delivery-note-right-align">
                            <p><strong>Sir,</strong></p>
                            <div className="letter-content">
                                <p><span className="highlight-text"><strong>Ref:</strong><strong><b> {invoiceData.reg_no} </b></strong>/ {invoiceData.bike_model} {invoiceData.bike_color}</span></p>
                                <p>
                                    I have this day purchased the above vehicle from you for the sum of Rs.<strong> <b>{invoiceData.amount}</b></strong> (Rupees in Words: <strong> {invoiceData.amountinwords}</strong>) and I have taken the delivery of the said vehicle to my entire satisfaction.
                                </p>
                                <p>
                                    The entire risk is being bome by me / us / from this time <strong>
                                        <b>
                                            {new Date(invoiceData.date_time).toLocaleString("en-GB", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true
                                            })}
                                        </b>
                                    </strong>
                                </p>
                            </div>
                        </div>

                        <div className="delivery-note-row">
                            {/* Left: Vehicle Details */}
                            <div className="delivery-note-vehicle-details">
                                <h3 className="delivery-note-fromto"><mark className="highlight-text">Vehicle Details</mark></h3>
                                <p><strong>Make:</strong><span>{invoiceData.bike_make_year}</span></p>
                                <p><strong>Chase No:</strong> <span>{invoiceData.bike_chase_no}</span></p>
                                <p><strong>Engine No:</strong> <span>{invoiceData.bike_engine_no}</span></p>
                                <p><strong><mark className="highlight-text">Exchange Details:</mark></strong></p>
                                <p><strong>Registration No:</strong><span> {invoiceData.exchange_reg_no}</span></p>
                                <p><strong>Exchange Bike:</strong><span> {invoiceData.exchange_bike_model}</span></p>
                                <p><strong>Color:</strong> <span>{invoiceData.exchange_bike_color}</span></p>
                                <p><strong>Exchange Amount:</strong> <span>{invoiceData.exchange_amount}</span></p>
                            </div>

                            {/* Right: Payment Details */}
                            <div className="delivery-note-payment">
                                <h3 className="delivery-note-fromto"><mark className="highlight-text">Payment Details</mark></h3>
                                <p><strong>1) Payment Type:</strong><span>{invoiceData.cash_paid1} / {invoiceData.payment_type1}</span></p>
                                <p><strong>2) Payment Type:</strong><span>{invoiceData.cash_paid2} / {invoiceData.payment_type2}</span></p>
                                <p><strong><mark className="highlight-text">Finance Details:</mark></strong></p>
                                <p><strong>Finance Amount:</strong><span> {invoiceData.finance_amount}</span></p>
                                <p><strong>EMI Tenure:</strong> <span>{invoiceData.emi_tenure}</span></p>
                                <p><strong>Monthly EMI:</strong> <span>{invoiceData.emi_amount}</span></p>
                                <p><strong>EMI Date:</strong> <span>{invoiceData.due_date}</span></p>

                            </div>
                        </div>

                        <div className="delivery-note-tamil-text">
                            <p><i className="fa fa-check-square"></i> இந்த வண்டியை தற்பொழுது இருக்கும் நிலையில் வாங்க சம்மதிக்கிறேன்.</p>
                            <p><i className="fa fa-check-square"></i> எந்த வித ரிப்பேர் செலவு வந்தாலும் நிர்வாகம் பொறுப்பல்ல.</p>
                            <p><i className="fa fa-check-square"></i> வண்டியை எடுத்துச் சென்ற பின் எக்காரணத்தை கொண்டும் திருப்பி எடுத்துக் கொள்ளப்பட மாட்டாது.</p>
                            <p><i className="fa fa-check-square"></i> வண்டி வாங்கிய 15 நாட்களுக்குள் பெயர் மாற்றிக்கொள்ள வேண்டும்.</p>
                        </div>

                        <div className="delivery-note-signatures">
                            <div>
                                <p>
                                    <strong>Signature of Buyer</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div >

    )

}

export default Billing